import { getColor } from '../../../../utils'
import { Container } from '../..'
import styled from 'styled-components'


const  StyledDropdownInput = styled(Container)`
  &.disabled{
    pointer-events: none;
    color: ${getColor('inactive')};
    user-select: none;
    .label-container{
      p{
        color: ${getColor('inactive')} !important;
      }
    }
  }
  &.default {
    border: 1px solid ${getColor('sigmaBorder')};
    &.active {
      border: 1px solid ${getColor('brand')}!important;
    }
    position: relative;
    cursor:pointer;
    transition: unset;
    .dropdown-body-container  {
      top: calc(100% + 1px);
      border: 1px solid ${getColor('sigmaBorder')};
      overflow: hidden;
      background: #FCFCFC;
      box-shadow: rgb(22 22 22 / 20%) 0px 4px 8px -2px;
      width: 400px;
      display: flex;
      flex-direction: column;
      .rdrDateRangePickerWrapper{
        font-family: 'GilroyRegular';
        .rdrDayToday:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span:after, .rdrDayToday:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span:after, .rdrDayToday:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span:after, .rdrDayToday:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span:after{
          background: #FBFAFF;
        }
        .rdrDayToday .rdrDayNumber span:after {
          background: ${getColor('brand')}; 
        }
      }
    }
    .options-container {
      z-index: 2;
      max-height: calc(50vh - 72px);
      overflow: auto;
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
      width: 100%;
      text-overflow: ellipsis;
      position: relative;
      .role-container {
        padding: 8px 12px;
        border: 1px solid #FBFAFF;
        justify-content: flex-start;
        min-height: 40px;
        align-items: center;
        &.checked-container{
          &:hover{
            border: 1px solid ${getColor('brand')};
          }
        }
        p {
          font-size: 12px;
          font-weight: 400;
          white-space: normal;
          word-wrap: break-word;
          overflow: visible;
          text-overflow: unset;
          max-width: 100%;
          width: 100%;
          line-height: 1.2;
        }
        &:hover {
          border: 1px solid ${getColor('sigmaBorder')};
        }
      }
      
      .role {
        padding: 8px 12px;
        border: 1px solid #FBFAFF;
        justify-content: flex-start;
        min-height: 40px;
        align-items: center;
        cursor: pointer;
        transition: all 0.2s ease;
        
        &:hover {
          border: 1px solid ${getColor('sigmaBorder')};
          background-color: #FBFAFF;
        }
        
        p {
          font-size: 12px;
          font-weight: 400;
          white-space: normal;
          word-wrap: break-word;
          overflow: visible;
          text-overflow: unset;
          max-width: 100%;
          width: 100%;
          line-height: 1.2;
        }
      }
      button.action-button {
        width: 75px;
        align-self: flex-end;
        margin-bottom: 8px;
        margin-right: 8px;
        position: sticky;
        bottom: 10px;
        right: 10px;
        background-color: #FBFAFF;
      }
      .message-container {
        max-width: 150px;
        align-self: center;
        text-align: center;
      }
    }
    .dropdown-body-container {
      z-index: 1;
      transition: unset;
      overflow: visible;
    }
    .trigger-container {
      width: 400px;
      padding: 3px 8px;
      min-height: 26px;
      height: auto;
      
      .label {
        p {
          font-weight: 400;
          font-size: 12px;
          max-width: 100%;
          overflow: visible;
          text-overflow: unset;
          white-space: normal;
          width: 100%;
          word-wrap: break-word;
          line-height: 1.1;
        }
      }

      p {
        max-width: 100%;
        overflow: visible;
        text-overflow: unset;
        white-space: normal;
        width: 100%;
        word-wrap: break-word;
        line-height: 1.1;
        font-size: 12px;
      }

      .h7 {
        max-width: 100% !important;
        overflow: visible !important;
        text-overflow: unset !important;
        white-space: normal !important;
        width: 100% !important;
        word-wrap: break-word !important;
        line-height: 1.1 !important;
        white-space: normal !important;
        font-size: 12px !important;
      }
    }
    .large-container{
      width: 280px;
    }
  }
  .bottom-option{
    display: flex;
    position: relative;
    bottom: 0;
    right: 0;
    left: 0;
    height: 28px;
    width: 100%;
    border-top: 1px solid ${getColor('sigmaBorder')};
    padding: 4px 8px;
    background-color: #F7F7F7;
    &.selected-option-label-container{
      justify-content: start;
      p{
        width: 100%;
        text-align: start;
        font-size: 12px;
        margin: 0;
        &.inactive{
          color: #686868;
        }
        &.active{
          color: ${getColor('brandDark')};
        }
      }

    }
    &.select-all-container{
      justify-content: flex-start;
      label{
        align-items: center;
        p{
          font-size: 12px;
          font-weight: 400;
          color: ${getColor('brand')};
        }
      }
    }
  }

`

export default StyledDropdownInput